import icons from 'country-flag-icons/react/3x2';
import { hasFlag } from 'country-flag-icons';

// styles
import styles from './country-selector.module.scss';

// utils
import { decodingContent } from 'utils/decodingContent';
import { classNameBuilder } from 'utils/classNameBuilder';
import { usePreviewIdBuilder } from 'utils/preview-id-builder';

interface CountrySelectorItemProps {
  country: Country;
}

export interface Country {
  countryCode: string;
  links: Link[];
  countryName: string;
  pictureAlt?: string;
}

interface Link {
  languageCode: string;
  url: string;
}

export const CountrySelectorItem: React.FC<CountrySelectorItemProps> = ({
  country = {
    links: [{ languageCode: '', url: '' }],
    countryCode: '',
    countryName: '',
    pictureAlt: '',
  },
}) => {
  const hasMultipleLanguages = country.links.length && country.links.length > 1;
  const countryCode = country.countryCode.toUpperCase();
  const CountryIcon = icons[countryCode];
  const previewIdBuilder = usePreviewIdBuilder();

  const innerContent = (
    <>
      {hasFlag(countryCode) && (
        <CountryIcon className={styles.flag} title={decodingContent(country.pictureAlt)} />
      )}
      <div className={styles.nameContainer}>
        <span className={styles.name} data-preview-id={previewIdBuilder('#st_countryName')}>
          {decodingContent(country.countryName)}
        </span>
      </div>
      {hasMultipleLanguages ? (
        country.links.map((link) => (
          <a
            className={styles.languageLinks}
            key={link.languageCode}
            href={link.url}
            target="_blank"
          >
            {link.languageCode}
          </a>
        ))
      ) : (
        <span className={styles.languageLinks} key={country.links[0]?.languageCode}>
          {country.links[0]?.languageCode}
        </span>
      )}
    </>
  );

  return hasMultipleLanguages ? (
    <div key={country.countryCode} className={styles.country}>
      {innerContent}
    </div>
  ) : (
    <a
      key={country.countryCode}
      className={classNameBuilder(styles.country, styles.singleLanguage)}
      href={country.links[0]?.url}
      target="_blank"
    >
      {innerContent}
    </a>
  );
};
